import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {
        // 查看/修改获取单条
        getList(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.GoodsListNum = []
            this.ListData = []
            $http.get("api/MeetOrder/GetMeetLinkOrderByIdEx", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.form = Data
                    if (Data.GiftList[0].ProNum < 8) {
                        this.form.ClassNum = 0
                    }
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo

                });
            });
        },

        //审核Order/OrderSendLessonAuditByFinance
        OrderSendLessonAuditByFinance() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/Order/OrderSendLessonAuditByFinance", Object.assign({}, params, this.auditFormData)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '审核成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false
                });
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addSendLessonView/services.js